import React from 'react';
import { Badge, Table, Row, Col, Card, Form, Button } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

const SmartDiscoverySection = ({
  suggestions,
  selectedSuggestion,
  setSelectedSuggestion,
  detailTransactions,
  quickTargetId,
  setQuickTargetId,
  handleQuickApprove,
  openAdvancedRuleCreator,
  accounts,
  plTypes,
  loading
}) => {
  return (
    <div className="mb-5">
      <h5 className="mb-3 text-muted small text-uppercase font-weight-bold d-flex align-items-center">
        <i className="fas fa-magic mr-2 text-primary"></i> Smart Rule Discovery
        {loading && <div className="spinner-border spinner-border-sm ml-3 text-primary" role="status"></div>}
      </h5>
      <div className="discovery-container border position-relative">
        {loading && (
          <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white opacity-75" style={{ zIndex: 10, left: 0, top: 0 }}>
            <div className="text-center">
              <div className="spinner-grow text-primary mb-3" role="status"></div>
              <div className="font-weight-bold text-primary">Analyzing your transactions...</div>
              <small className="text-muted">This may take a few seconds</small>
            </div>
          </div>
        )}
        
        {/* LEFT: MASTER LIST */}
        <div className="discovery-master">
          {suggestions.map((s, idx) => (
            <div 
              key={idx} 
              className={`suggestion-card ${selectedSuggestion?.description === s.description ? 'active' : ''}`}
              onClick={() => setSelectedSuggestion(s)}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="text-truncate mr-2" style={{ fontWeight: 600 }}>{s.description}</div>
                <Badge variant="primary" pill>{s.count}</Badge>
              </div>
              <div className="small text-muted text-truncate mt-1">{s.original}</div>
            </div>
          ))}
        </div>

        {/* RIGHT: DETAIL VIEW */}
        <div className="discovery-detail">
          {selectedSuggestion ? (
            <div>
              <div className="mb-4">
                <h4 className="mb-1">{selectedSuggestion.description}</h4>
                <p className="small text-muted">Found {selectedSuggestion.count} transactions totaling ${Math.abs(selectedSuggestion.totalAmount).toFixed(2)}</p>
              </div>

              <div className="mb-4">
                <h6 className="small font-weight-bold text-uppercase text-muted">Transactions Preview</h6>
                <div style={{ maxHeight: '150px', overflowY: 'auto' }} className="border rounded bg-light">
                  <Table size="sm" hover className="mb-0 bg-transparent">
                    <tbody>
                      {detailTransactions.map(tx => (
                        <tr key={tx._id} className="small">
                          <td>{new Date(tx.date).toLocaleDateString()}</td>
                          <td className="text-truncate" style={{ maxWidth: '180px' }}>{tx.description}</td>
                          <td className="text-right font-weight-bold">${tx.amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>

              <hr />

              <Row>
                <Col md={12}>
                  <h6 className="font-weight-bold mb-3">How would you like to handle this group?</h6>
                  
                  {/* Option 1: Quick Categorize */}
                  <Card className="mb-3 border-success shadow-sm">
                    <Card.Body className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 text-success"><i className="fas fa-bolt mr-1"></i> Option 1: Quick Categorize</h6>
                      </div>
                      <Row noGutters>
                        <Col>
                          <SearchableSelect 
                            options={accounts.filter(a => plTypes.includes(a.type)).map(acc => ({ value: acc._id, label: acc.name, sublabel: acc.type }))}
                            value={quickTargetId} 
                            onChange={(e) => setQuickTargetId(e.target.value)}
                            placeholder="-- Select Category --"
                          />
                        </Col>
                        <Col xs="auto" className="ml-2">
                          <Button variant="success" size="sm" onClick={handleQuickApprove}>
                            Apply to All
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>

                  {/* Option 2: Create Advanced Rule */}
                  <Card className="border-primary shadow-sm">
                    <Card.Body className="p-3">
                      <h6 className="mb-2 text-primary"><i className="fas fa-cog mr-1"></i> Option 2: Create Advanced Rule</h6>
                      <p className="small text-muted mb-3">Set custom operators like "Is Exactly" or "Doesn't Contain" for more precision.</p>
                      <Button variant="outline-primary" size="sm" block onClick={openAdvancedRuleCreator}>
                        Open Rule Creator
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="discovery-placeholder">
              <i className="fas fa-magic fa-3x mb-3 text-light"></i>
              <p>Select a payee from the left to start discovery</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SmartDiscoverySection;
